import { Theme } from 're-exports'
import { css } from 'theme-ui'

export function getCSS(theme: Theme) {
    return (property: string, value: string | number): string => {
        // @ts-ignore: this is too much speculation for TS
        return css({ [property]: value })(theme)[property]
    }
}
